import { NEW_RELIC_SCRIPTS } from './newRelic'
import * as LOG_ROCKET from './logRocket'
import Bugsnag from '@bugsnag/js'
import React from 'react'
import BugsnagReact from '@bugsnag/plugin-react'
import LogRocket from 'logrocket'
import * as commandbar from 'commandbar'

export const bugsnagClient = Bugsnag.start({
  apiKey: '0ee0a0d12ac0b02b55f58c1169b8d2d8',
  releaseStage: window.location.hostname,
  onError: (event) => {
    event.addMetadata('LogRocket', {
      sessionURL: LogRocket.sessionURL,
    })
  },
  logger: console,
  plugins: [new BugsnagReact()],
})

export const BugsnagErrorBoundary =
  Bugsnag.getPlugin('react').createErrorBoundary(React)

let USER_INFO = null

export const TRACKERS = Object.freeze({
  FULLSTORY: {
    SCRIPT: `
window['_fs_debug'] = true;
window['_fs_host'] = 'fullstory.com';
window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
window['_fs_org'] = '${process.env.REACT_APP_FULLSTORY_CODE}';
window['_fs_namespace'] = 'FS';
(function(m,n,e,t,l,o,g,y){
    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
    g.anonymize=function(){g.identify(!!0)};
    g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
    g.log = function(a,b){g("log",[a,b])};
    g.consent=function(a){g("consent",!arguments.length||a)};
    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
    g.clearUserCookie=function(){};
    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
    g._v="1.2.0";
})(window,document,window['_fs_namespace'],'script','user');
`,
    IDENTIFY(id, userInfo) {
      window.FS && window.FS.identify(id, userInfo)
    },
    TRACK(label, metaData) {
      window.FS && window.FS.event && window.FS.event(label, metaData)
    },
  },
  HEAP_ANALYTICS: {
    SCRIPT: `window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
  heap.load("${process.env.REACT_APP_HEAP_ANALYTICS_CODE}");`,
    IDENTIFY(id, userData) {
      window.heap && window.heap.identify && window.heap.identify(id)
      window.heap &&
        window.heap.addUserProperties &&
        window.heap.addUserProperties(userData)
    },
    TRACK(label, metaData) {
      window.heap &&
        window.heap.track &&
        window.heap.track(label, metaData)
    },
  },
  AMPLITUDE_ANALYTICS: {
    SCRIPT: `  (function(e,t){var n=e.amplitude||{_q:[],_iq:{}};var r=t.createElement("script")
  ;r.type="text/javascript";r.async=true
  ;r.src="https://cdn.amplitude.com/libs/amplitude-4.5.2-min.gz.js"
  ;r.onload=function(){if(e.amplitude.runQueuedFunctions){
  e.amplitude.runQueuedFunctions()}else{
  console.log("[Amplitude] Error: could not load SDK")}}
  ;var i=t.getElementsByTagName("script")[0];i.parentNode.insertBefore(r,i)
  ;function s(e,t){e.prototype[t]=function(){
  this._q.push([t].concat(Array.prototype.slice.call(arguments,0)));return this}}
  var o=function(){this._q=[];return this}
  ;var a=["add","append","clearAll","prepend","set","setOnce","unset"]
  ;for(var u=0;u<a.length;u++){s(o,a[u])}n.Identify=o;var c=function(){this._q=[]
  ;return this}
  ;var l=["setProductId","setQuantity","setPrice","setRevenueType","setEventProperties"]
  ;for(var p=0;p<l.length;p++){s(c,l[p])}n.Revenue=c
  ;var d=["init","logEvent","logRevenue","setUserId","setUserProperties","setOptOut",
  "setVersionName","setDomain","setDeviceId","setGlobalUserProperties","identify",
  "clearUserProperties","setGroup","logRevenueV2","regenerateDeviceId","logEventWithTimestamp",
  "logEventWithGroups","setSessionId","resetSessionId"]
  ;function v(e){function t(t){e[t]=function(){
  e._q.push([t].concat(Array.prototype.slice.call(arguments,0)))}}
  for(var n=0;n<d.length;n++){t(d[n])}}v(n);n.getInstance=function(e){
  e=(!e||e.length===0?"$default_instance":e).toLowerCase()
  ;if(!n._iq.hasOwnProperty(e)){n._iq[e]={_q:[]};v(n._iq[e])}return n._iq[e]}
  ;e.amplitude=n})(window,document);

  amplitude.getInstance().init("${process.env.REACT_APP_AMPLITUDE_KEY}");`,
    IDENTIFY(id, userData) {
      if (window.amplitude && window.amplitude.Identify) {
        const { Identify } = window.amplitude
        const identity = new Identify()
        identity.set('id', id)
        Object.entries(userData).forEach(([key, val]) => {
          identity.set(key, val)
        })
      }
    },
    TRACK(label, metaData) {
      window.amplitude &&
        window.amplitude.logEvent &&
        window.amplitude.logEvent(label, metaData)
    },
  },
  SEGMENT_ANALYTICS: {
    SCRIPT: `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement("script");n.type="text/javascript";n.async=!0;n.src="https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};analytics.SNIPPET_VERSION="4.1.0";
  analytics.load('${process.env.REACT_APP_SEGMENT_CODE}');
  analytics.page();
  }}();
  `,
    IDENTIFY(id, userInfo) {
      window.analytics && window.analytics.identify(id, userInfo)
    },
    TRACK(label, metaData) {
      window.analytics && window.analytics.track(label, metaData)
    },
  },
  LOG_ROCKET: {
    INIT: LOG_ROCKET.init,
    IDENTIFY: LOG_ROCKET.identify,
    TRACK: LOG_ROCKET.track,
  },
  NEW_RELIC: {
    SCRIPT:
      process.env.NODE_ENV !== 'development'
        ? NEW_RELIC_SCRIPTS.PRODUCTION
        : '',
  },
  COMMANDBAR: {
    INIT: ({ isProduction }) => {
      commandbar?.init?.('492d637f')
    },
    IDENTIFY(id, userInfo) {
      if (userInfo?.commandBarHmac) {
        window?.CommandBar?.boot?.(id, userInfo, {
          hmac: userInfo.commandBarHmac,
        })
      } else {
        window?.CommandBar?.boot?.(id, userInfo)
      }
    },
    initEverywhere: true,
  },
  BUGSNAG: {
    IDENTIFY(id, userInfo) {
      Bugsnag.setUser(id, userInfo?.email, userInfo?.name)
      Bugsnag.addMetadata('User metadata', userInfo)
    },
    TRACK: (type, metadata) =>
      Bugsnag.leaveBreadcrumb(type, metadata),
  },
})

/**
 * Identify the user across all of our tracking tools
 * @param {string} id
 * @param {{ name?:string, email?:string, isAdmin?:boolean, accountId?:string, accountName?:string, ... }} userInfo
 * @return
 */
export function identifyUser(
  id,
  userInfo = {},
  isProduction = false,
) {
  if (!id) {
    console.error('Trying to identify user without ID')
    return
  }
  Object.values(TRACKERS).forEach((tracker) => {
    if (tracker?.initEverywhere || isProduction) {
      tracker.IDENTIFY && tracker.IDENTIFY(id, userInfo)
    }
  })

  USER_INFO = userInfo
}

export function initializeScripts({ isProduction }) {
  Object.values(TRACKERS).forEach((tracker) => {
    if (tracker?.initEverywhere || isProduction) {
      tracker?.INIT?.({
        isProduction,
      })
    }
  })
}

/**
 * Identify the user across all of our tracking tools
 * @param {{ type?:string, ...}} action
 * @return
 */
export function trackActions(action = {}) {
  const { type, ...metaData } = action
  if (!type) {
    console.error('Trying to log action without type')
    return
  }
  Object.values(TRACKERS).forEach(
    (tracker) =>
      tracker?.TRACK &&
      tracker.TRACK(type, {
        ...metaData,
        ...(USER_INFO ? { user: USER_INFO } : {}),
      }),
  )
}

export const SCRIPTS = Object.values(TRACKERS).map(
  (tracker) => tracker?.SCRIPT || '',
)
